const deep_sapphire = {
		DEFAULT: "#083B66",
		50: "#369BEF",
		100: "#2391EE",
		200: "#117DD7",
		300: "#0E67B2",
		400: "#0B518C",
		500: "#083B66",
		600: "#041D32",
		700: "#000000",
		800: "#000000",
		900: "#000000",
		950: "#000000",
	},
	sunglow = {
		DEFAULT: "#FFCD27",
		50: "#FFF8DF",
		100: "#FFF3CA",
		200: "#FFE9A1",
		300: "#FFE079",
		400: "#FFD650",
		500: "#FFCD27",
		600: "#EEB700",
		700: "#B68C00",
		800: "#7E6100",
		900: "#463500",
		950: "#2A2000",
	},
	max_screen = 1920;

export default {
	extend: {
		page: {
			gap: {
				0: "2rem",
				xl: "4rem",
			},
			mt: {
				0: "2.125rem",
				xl: "1.75rem",
			},
		},
		transitionDuration: {
			DEFAULT: "500ms",
		},
		header: {
			height: {
				0: "114.95px",
				xl: "156.1px",
			},
			curveHeight: {
				0: "15px",
				xl: "29px",
			},
		},
		button: {
			height: 46,
			paddingX: 40,
		},
		fontFamily: {
			montserrat: ["Montserrat", "sans-serif"],
			"playfair-display": ["Playfair Display", "serif"],
			rawson: ["Rawson", "sans-serif"],
		},
		fontData: {
			montserrat: {
				ascender: 968,
				descender: -251,
				capitalHeight: 700,
				emSize: 1000,
			},
			"playfair-display": {
				ascender: 1082,
				descender: -251,
				capitalHeight: 708,
				emSize: 1000,
			},
			rawson: {
				ascender: 1070,
				descender: -250,
				capitalHeight: 662,
				emSize: 1100,
			},
		},
		elements: {
			h1: "aligned-font-playfair-display font-bold text-2xl leading-8",
			h2: "aligned-font-playfair-display font-bold text-[1.375rem] leading-relaxed",
			h3: "aligned-font-playfair-display font-bold text-xl leading-[2.125rem]",
			h4: "aligned-font-montserrat font-bold text-lg leading-snug",
			h5: "aligned-font-montserrat font-bold text-lg leading-snug",
			h6: "aligned-font-montserrat font-bold text-base leading-snug",
			p: "aligned-font-montserrat text-base leading-snug",
			a: "safe-transition cursor-pointer",
			input: "safe-transition cursor-pointer",
			label: "safe-transition cursor-pointer",
			button: "safe-transition cursor-pointer",
		},
		screens: {
			0: "0px",
			xs: "375px",
			"after-xs": "376px",
			max: `${max_screen}px`,
		},
		container: {
			center: true,
			maxWidth: {
				0: "80%",
				max: `${max_screen * 0.8}px`,
			},
		},
		colors: {
			transparent: "transparent",
			current: "currentColor",
			"body-background": "#ffffff",
			black: "#000000",
			white: "#ffffff",
			primary: deep_sapphire,
			secondary: sunglow,
			"deep-sapphire": deep_sapphire,
			mystic: {
				DEFAULT: "#E6EBEF",
				50: "#FFFFFF",
				100: "#FFFFFF",
				200: "#FFFFFF",
				300: "#FFFFFF",
				400: "#FFFFFF",
				500: "#E6EBEF",
				600: "#C4D0D9",
				700: "#A2B4C3",
				800: "#7F99AD",
				900: "#5F7D95",
				950: "#556F84",
			},
			"guardsman-red": {
				DEFAULT: "#D30000",
				50: "#FF8C8C",
				100: "#FF7777",
				200: "#FF4E4E",
				300: "#FF2626",
				400: "#FC0000",
				500: "#D30000",
				600: "#9B0000",
				700: "#630000",
				800: "#2B0000",
				900: "#000000",
				950: "#000000",
			},
			coral: {
				DEFAULT: "#FF7B49",
				50: "#FFFFFF",
				100: "#FFF1EC",
				200: "#FFD4C3",
				300: "#FFB69B",
				400: "#FF9972",
				500: "#FF7B49",
				600: "#FF5211",
				700: "#D83B00",
				800: "#A02C00",
				900: "#681C00",
				950: "#4C1500",
			},
			sunglow,
			"crown-of-thorns": {
				DEFAULT: "#6E1D33",
				50: "#D86B88",
				100: "#D45B7B",
				200: "#CB3A62",
				300: "#AF2E51",
				400: "#8E2642",
				500: "#6E1D33",
				600: "#42111E",
				700: "#15060A",
				800: "#000000",
				900: "#000000",
				950: "#000000",
			},
		},
	},
};
